import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useEditorWebsocket } from "@hooks";
import { useEstimateStructure } from "@tools";
import { getStructureMetadata } from "@utils";
import { ActionButton } from "@components";
import { Badge, Grid, Tooltip } from "@material-ui/core";
import { Redo, Stacks, Undo } from "@assets";
import useStyle from "./ActionPanel.style";

export const ActionPanel = observer(() => {
  const { t } = useTranslation();
  const socket = useEditorWebsocket();
  const structure = useEstimateStructure();
  const classes = useStyle();
  
  const handleUndo = (e) => {
    e.preventDefault();
    if(!structure.historyManager?.undoLevels)
      return;
    const patches = structure.historyManager?.history[structure.historyManager?.undoIdx - 1].inversePatches.slice().reverse();
    structure.historyManager?.undo();
    handleCommentPatches(patches);
  }
  
  const handleRedo = (e) => {
    e.preventDefault();
    if(!structure.historyManager?.redoLevels)
      return;
    const patches = structure.historyManager?.history[structure.historyManager?.undoIdx].patches;
    structure.historyManager?.redo();
    handleCommentPatches(patches);
  }
  
  const handleTurnOffBuffers = () => {
    structure.turnOffAllBuffers(!structure.allBuffersOff);
  }
  
  const handleCommentPatches = (patches) => {
    if(patches.length > 0) {
      patches.forEach(p => {
        if(p.op === "comment")
          socket?.requestCommentMove(p.path, p.value);
        if(p.op === "commentName")
          socket?.requestCommentPathElementRename(p.path, p.value);
      });
      socket?.requestStructurePatch?.(patches.filter(p => p.op !== "comment" && p.op !== "commentName"), getStructureMetadata(structure));
    }
  }
  
  return (
    <Grid item container className={ classes.actionContainer }>
      <Tooltip title={t("common.undo")}>
        <ActionButton
          square
          size="small" color="secondary"
          onClick={handleUndo}
        >
          <Undo />
        </ActionButton>
      </Tooltip>
      <Tooltip title={t("common.redo")}>
        <ActionButton
          square
          size="small" color="secondary"
          onClick={handleRedo}
        >
          <Redo />
        </ActionButton>
      </Tooltip>
      <Badge
        color={structure.usedBuffers ? "primary" : "secondary"}
        badgeContent={structure.previouslyUsedBuffers}
        overlap="circular"
        max={99}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Tooltip title={t(`views.editor.dialogs.buffers.turn_off_all.${structure.allBuffersOff ? "on" : "off"}`)}>
          <ActionButton
            square
            size="small" color="secondary"
            onClick={handleTurnOffBuffers}
          >
            <Stacks />
          </ActionButton>
        </Tooltip>
      </Badge>
      
      
      
      <div className={classes.color} />
    </Grid>
  )
})